const calcDigit = (cpf, fator) => {
  let total = 0
  for (let i = 0; i < cpf.length; i++) {
    total += parseInt(cpf.charAt(i), 10) * (fator - i)
  }
  const resto = total % 11
  return resto < 2 ? 0 : 11 - resto
}

const validate = {
  // numeros
  numbers: {
    cpf(cpf) {
      const cpfClean = cpf.replace(/\D/g, '')

      if (!/^\d{11}$/.test(cpfClean)) {
        return false
      }

      // Verificar se todos os dígitos são iguais
      if (/^(\d)\1+$/.test(cpfClean)) {
        return false
      }

      // Extrair os 9 primeiros dígitos
      const baseCPF = cpfClean.substring(0, 9)

      // Calcular os dígitos verificadores
      const d1 = calcDigit(baseCPF, 10)
      const d2 = calcDigit(baseCPF + d1, 11)

      // Verificar se os dígitos calculados correspondem aos fornecidos
      return cpfClean.endsWith(d1.toString() + d2.toString()) ? 'CPF' : false
    },
    cnpj(cnpj) {
      const cnpjClean = String(cnpj ?? '').replace(/\D/g, '')

      // Verifica se o CNPJ tem 14 dígitos
      if (cnpjClean.length !== 14) {
        return false
      }

      // Verifica se todos os dígitos são iguais
      if (/^(\d)\1+$/.test(cnpjClean)) {
        return false
      }

      const cnpjArray = cnpjClean.split('').map(Number)

      // Função auxiliar para calcular o dígito verificador
      const calcDV = (baseArray, multiplicadores) => {
        const soma = baseArray.reduce((acc, num, index) => {
          return acc + num * multiplicadores[index]
        }, 0)
        const resto = soma % 11
        return resto < 2 ? 0 : 11 - resto
      }

      // Multiplicadores para o cálculo do primeiro e segundo dígitos
      const multiplicadores1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
      const multiplicadores2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

      const digito1 = calcDV(cnpjArray.slice(0, 12), multiplicadores1)
      const digito2 = calcDV(cnpjArray.slice(0, 13), multiplicadores2)

      return digito1 === cnpjArray[12] && digito2 === cnpjArray[13]
    },

    cep(cep) {
      if (!cep) return null
      return /[0-9]{5}-[0-9]{3}/.test(cep) && cep.length === 9
    },
    numero(numero) {
      if (!numero) return null
      return /^[0-9]+$/.test(numero) && numero.length > 0
    },
    cellphone(cellnumber) {
      if (!cellnumber) return null
      return /^(\d{11})$/.test(cellnumber)
    },
    cellphonePix(cellnumber) {
      if (!cellnumber) return null
      return /^\+55 \(\d{2}\) \d{5}-\d{4}$/.test(cellnumber)
    },
    password(password) {
      if (!password) return null
      return /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[!"#\$%&'\(\)\*\+,-\.\/:;<=>\?@[\]\^_`\{\|}~])[a-zA-Z0-9!"#\$%&'\(\)\*\+,-\.\/:;<=>\?@[\]\^_`\{\|}~]{6}$/.test(
        password
      )
    },
  },

  // strings
  string: {
    name(name) {
      if (!name) return null
      return (
        typeof name === 'string' &&
        /^[A-Za-zÁ-Úá-úÂ-Ûâ-û^~ ]*$/.test(name) &&
        name.length > 3
      )
    },
    email(email) {
      if (!email) return null
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    },
    endereco(address) {
      // serve para rua, bairro, cidade e complemento
      if (!address) return null
      return /^[A-Za-zÁ-Úá-ú0-9 ]*$/.test(address) && address.length > 3
    },
  },

  // datas
  date: {
    date(date, notBirth = true) {
      const now = new Date()
      const currentY = now.getFullYear()
      const dateformat =
        /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/
      if (date.match(dateformat)) {
        const [dd, mm, yy] = date.split('/')
        const ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
        if (mm === 1 || (mm > 2 && dd > ListofDays[mm - 1])) return false
        if (mm === 2) {
          let lyear = false
          if ((!(yy % 4) && yy % 100) || !(yy % 400)) lyear = true
          if (!lyear && dd >= 29) return false
          if (lyear && dd > 29) return false
        }
        if (yy > currentY) return false
        if (yy < currentY - 100) return false
        if (yy > currentY - 18 && notBirth) return 'de menor'
        return true
      }
      return false
    },
  },
}

export default validate
